import { Amplify } from 'aws-amplify';
import { useSettings } from '@/config/settings';

const amplify = {
  initialize: () => {
    const { settings } = useSettings();

    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: settings.amplify.userPoolId,
          userPoolClientId: settings.amplify.userPoolWebClientId,
        },
      },
    });
  },
};

export default amplify;
